import { render, staticRenderFns } from "./Endorsement.vue?vue&type=template&id=99f5a3ce&"
import script from "./Endorsement.vue?vue&type=script&lang=js&"
export * from "./Endorsement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports